import nationalSecretStyle from '@/assets/themes/nationalSecret.scss'
import publicStyle from '@/assets/themes/public.scss'
export const Themes = {
  computed: {
    themesStyle() {
      if(localStorage.getItem('system') == 'pub') {
        return  publicStyle
      } 
      return nationalSecretStyle
    },
    systemName() {
      if(localStorage.getItem('system') == 'pub') {
        return  this.$t('title.pub')
      } 
      return '联盟区块链开发辅助平台'
    },
  },
}